import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/client";
import type { Agent, AgentListResponse } from "@/types";

export function useAgents() {
  return useQuery<Agent[]>({
    queryKey: ["agents"],
    queryFn: async () => {
      const res = await apiClient.get<AgentListResponse>("/agents");
      return res.data.agents;
    },
  });
}

export function useAgent(id: string | undefined) {
  return useQuery<Agent>({
    queryKey: ["agents", id],
    queryFn: async () => {
      const res = await apiClient.get<Agent>(`/agents/${id}`);
      return res.data;
    },
    enabled: !!id,
  });
}
